import { apiRequest } from '@/lib/api/client';
import type {
  ContentCreatePayload,
  PublicContentDetail,
  SocialHandoffOut,
  SocialHandoffPayload,
} from './types';

export const publisherApi = {
  createContent: (payload: ContentCreatePayload): Promise<PublicContentDetail> =>
    apiRequest<PublicContentDetail>('/public/content', {
      method: 'POST',
      channel: 'platform',
      body: payload,
    }),

  updateContent: (
    id: string,
    payload: Partial<ContentCreatePayload>,
  ): Promise<PublicContentDetail> =>
    apiRequest<PublicContentDetail>(`/public/content/${id}`, {
      method: 'PATCH',
      channel: 'platform',
      body: {
        ...Object.fromEntries(
          Object.entries(payload).map(([key, value]) => [key, value === undefined ? null : value]),
        ),
        ...(payload.meta
          ? {
              meta: Object.fromEntries(
                Object.entries(payload.meta).map(([key, value]) => [
                  key,
                  value === undefined ? null : value,
                ]),
              ),
            }
          : {}),
      },
    }),

  submitForModeration: (id: string): Promise<PublicContentDetail> =>
    apiRequest<PublicContentDetail>(`/public/content/${id}/submit`, {
      method: 'POST',
      channel: 'platform',
    }),

  publishContent: (id: string): Promise<PublicContentDetail> =>
    apiRequest<PublicContentDetail>(`/public/content/${id}/publish`, {
      method: 'POST',
      channel: 'platform',
    }),

  createHandoff: (payload: SocialHandoffPayload): Promise<SocialHandoffOut> =>
    apiRequest<SocialHandoffOut>('/public/social-handoff', {
      method: 'POST',
      channel: 'platform',
      body: payload,
    }),
};
